import React, {useState} from "react";
import FileUpload from "../components/FileUpload.jsx";
import DocumentTab from "../components/onboarding-documents/DocumentsTab.jsx";
import FileUploadComponent from "../components/onboarding-documents/SectionUploads.jsx";
import AdditionalDetails from "../components/onboarding-documents/AdditionalDetailsNew.jsx";

const UploadPage = () => {
  const hunterID = 11;
  const leadID = 12393;

  return (
    <div className="p-4 flex-col flex">
      <DocumentTab leadID = {leadID}/>
      <AdditionalDetails 
        leadID = {leadID}
        hunterID = {hunterID}/>
    </div>
  );
}

export default UploadPage;
